import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ApiConstants } from '../../common/constants/api-url.constant';
import { PressRelease } from '../../common/models/press-release.model';

@Injectable({
  providedIn: 'root',
})
export class PressReleaseService {
  private http = inject(HttpClient);
  private apiConstants = inject(ApiConstants);

  /** Get all press releases, return empty list if API returns null or error */
  getAllPressRelease(): Observable<PressRelease[]> {
    return this.http.get<PressRelease[]>(this.apiConstants.GET_ALL_PRESS_RELEASE()).pipe(
      map((data) => data ?? []),
      catchError((err) => {
        console.error('Error fetching press releases:', err);
        return of([]); // return empty list on error
      })
    );
  }

  /** Get press release by ID, return null if not found or error */
  getPressReleaseById(id: number): Observable<PressRelease | null> {
    return this.http.get<PressRelease | null>(this.apiConstants.GET_PRESS_RELEAS_BY_ID(id)).pipe(
      catchError((err) => {
        console.error(`Error fetching press release with id ${id}:`, err);
        return of(null); // return null on error
      })
    );
  }
}
